/**
 * @generated SignedSource<<8fbc72e11be767035b0993486a69ffd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRoleInput = {
  roleId: string;
};
export type Role_deleteRole_Mutation$variables = {
  input: DeleteRoleInput;
};
export type Role_deleteRole_Mutation$data = {
  readonly deleteRole: {
    readonly role: {
      readonly id: string;
    };
  } | null;
};
export type Role_deleteRole_Mutation = {
  response: Role_deleteRole_Mutation$data;
  variables: Role_deleteRole_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteRolePayload",
    "kind": "LinkedField",
    "name": "deleteRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Role",
        "kind": "LinkedField",
        "name": "role",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Role_deleteRole_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Role_deleteRole_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8390ce0402dd59b2f7fc9f1372a4570",
    "id": null,
    "metadata": {},
    "name": "Role_deleteRole_Mutation",
    "operationKind": "mutation",
    "text": "mutation Role_deleteRole_Mutation(\n  $input: DeleteRoleInput!\n) {\n  deleteRole(input: $input) {\n    role {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "817ece1946ed43ec4033d7e141fcbb0a";

export default node;
